import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Area, DataApiResponseLegacy, EntryOrder, RoomBlock, SeatType } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AreasApiService {
  readonly areasBaseUrl = '/api/v1.0/areas';
  constructor(private http: HttpClient) {}

  addArea(area) {
    return this.http.post(`${this.areasBaseUrl}`, area);
  }

  addRoomBlock(areaId: string, body: RoomBlock) {
    return this.http.post<RoomBlock>(`${this.areasBaseUrl}/${areaId}/block`, body);
  }

  updateRoomBlock(areaId: string, body: RoomBlock) {
    return this.http.put<RoomBlock>(`${this.areasBaseUrl}/${areaId}/block`, body);
  }

  removeRoomBlock(areaId: string, roomBlockId: RoomBlock) {
    return this.http.delete<RoomBlock>(`${this.areasBaseUrl}/${areaId}/block/${roomBlockId}`);
  }

  updateArea(area) {
    return this.http.put<Area>(`${this.areasBaseUrl}`, area);
  }

  updateAreasOrder(orderData: EntryOrder[]): Observable<any> {
    return this.http.post<any>(`${this.areasBaseUrl}/order`, { areas: orderData });
  }

  cloneArea(area) {
    return this.http.post<Area>(`${this.areasBaseUrl}/clone`, area);
  }

  getAreas(queryParams) {
    return this.http.get<DataApiResponseLegacy<Area[]>>(`${this.areasBaseUrl}`, { params: queryParams });
  }

  getArea(id: string) {
    return this.http.get<Area>(`${this.areasBaseUrl}/${id}`);
  }

  removeArea(id: string) {
    return this.http.delete(`${this.areasBaseUrl}/${id}`);
  }

  uploadAreaSVG(file: File, reportProgress = true, areaId: string): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);

    let params = new HttpParams();
    params = params.append('AreaId', areaId);

    const req = new HttpRequest('POST', `${this.areasBaseUrl}/seats/import`, formData, { reportProgress, params });
    return this.http.request(req);
  }

  getAreaSVG(areaId: string, theme: number) {
    return this.http.get(`${this.areasBaseUrl}/${areaId}/${theme}/seats/download`, { responseType: 'text' });
  }

  attachSeatTypes(areaId: string, body) {
    return this.http.post<DataApiResponseLegacy<SeatType[]>>(`${this.areasBaseUrl}/${areaId}/seats/types/attach`, body);
  }

  assignSeatsToCategories(
    areaId: string,
    body: { assignments: { seat_category_id: string | null; seat_ids: string[] }[] }
  ) {
    return this.http.put<void>(`${this.areasBaseUrl}/${areaId}/seats/categories`, body);
  }
}
